import {
  AllTableColumn,
  AllTableSorting,
  ProductGroupName,
} from '@prlw/core/monitor/types/all-table';

const BASIS = 'Завод';

export const allTableColumns: AllTableColumn[] = [
  {
    name: ProductGroupName.REG,
  },
  {
    name: ProductGroupName.PRM,
  },
  {
    name: ProductGroupName.DTL,
  },
  {
    name: ProductGroupName.DTM,
  },
  {
    name: ProductGroupName.DTZ,
  },
  {
    name: ProductGroupName.TRD,
  },
  {
    name: ProductGroupName.MZT,
  },
  {
    name: ProductGroupName.SUG,
  },
  {
    name: ProductGroupName.DTA,
  },
  {
    name: ProductGroupName.GKS,
  },
  {
    name: ProductGroupName.SPR,
  },
  {
    name: ProductGroupName.I00,
  },
  {
    name: ProductGroupName.OIL,
  },
];

export const allTableSortDefaults: AllTableSorting[] = [
  { columnName: BASIS, direction: 'ASC' },
  { columnName: ProductGroupName.REG, direction: 'ASC' },
  { columnName: ProductGroupName.PRM, direction: 'ASC' },
  { columnName: ProductGroupName.DTL, direction: 'ASC' },
  { columnName: ProductGroupName.DTM, direction: 'ASC' },
  { columnName: ProductGroupName.DTZ, direction: 'ASC' },
  { columnName: ProductGroupName.TRD, direction: 'ASC' },
  { columnName: ProductGroupName.MZT, direction: 'ASC' },
  { columnName: ProductGroupName.SUG, direction: 'ASC' },
  { columnName: ProductGroupName.DTA, direction: 'ASC' },
  { columnName: ProductGroupName.GKS, direction: 'ASC' },
  { columnName: ProductGroupName.SPR, direction: 'ASC' },
  { columnName: ProductGroupName.I00, direction: 'ASC' },
  { columnName: ProductGroupName.OIL, direction: 'ASC' },
];
